<template>
  <el-row :gutter="15">
    <el-col :span="24">
      <Filters
        class="mb-3"
        :resource="$sdk.dictionary_location"
        :filters.sync="filters"
        context="dictionary"
        @apply="reload"
        @ready="loadLocationList"
      />
      <el-card shadow="never">
        <LocationsTable
          ref="location"
          v-loading="isLoading"
          :locations="locations"
          @refresh="loadLocationList"
          @edit="edit"
        />
        <br>
        <div style="text-align: center;">
          <el-pagination
            :current-page.sync="locations.page"
            :page-size.sync="locations.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="locations.total"
            @size-change="reload()"
            @current-change="reload()"
          />
        </div>
        <LocationForm
          ref="locationForm"
          :form="form"
          :operator="operator"
          @save="save"
          @update="update"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import LocationsTable from '@/components/Application/Manage/Locations/LocationsTable'
import LocationForm from '@/components/Application/Manage/Locations/LocationFormDialog'
import Filters from '@/components/Filters/Complex'
import { CREATE } from '@/plugins/user'

export default {
  components: {
    LocationsTable,
    LocationForm,
    Filters
  },
  data () {
    return {
      actions: [
        {
          hidden: this.$user.cannot(CREATE, 'dictionary_location'),
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.reset()
            this.operator = true
            this.$refs.locationForm.showForm()
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => {
            this.loadLocationList()
          }
        }
      ],
      form: {
        country: null, suburb: null, state: null, pobox: null, postcode: null
      },
      locations: [],
      page: 1,
      perPage: 10,
      total: 0,
      isLoading: false,
      operator: false,
      filters: []
    }
  },
  methods: {
    loadLocationList () {
      this.isLoading = true
      this.$sdk.dictionary_location.list(builder => {
        builder.order = 'suburb:asc'
        builder.filters = this.filters
      })
        .then(res => {
          this.locations = res
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async reload () {
      try {
        this.isLoading = true
        await this.locations.reload(builder => { builder.filters = this.filters })
      } catch {
        this.$message.error('An error occurred while loading data')
      } finally {
        this.isLoading = false
      }
    },
    save () {
      this._loading()
      this.$sdk.dictionary_location.create(this.form).then((res) => this.$message({ message: 'Successfully saved', type: 'success' }))
        .finally(() => {
          this._closing()
          this.loadLocationList()
          this.$refs.locationForm.closeForm()
        })
    },
    edit (row) {
      this.form = row
      this.operator = false
      this.$refs.locationForm.showForm()
    },
    update () {
      this._loading()
      this.form.update().then((res) => this.$message({ message: 'Successfully saved', type: 'success' }))
        .finally(() => {
          this._closing()
          this.loadLocationList()
          this.$refs.locationForm.closeForm()
        })
    },
    _loading () {
      this.isLoading = true
    },
    _closing () {
      this.isLoading = false
    },
    reset () {
      this.form = {
        country: null, suburb: null, state: null, pobox: false, postcode: null
      }
    }
  }
}
</script>

<style>

</style>
